module.exports = __webpack_public_path__ + "img/pp_delete_24.e9db88e2.svg";